<template>
    <v-navigation-drawer class="app-menu appmenubg" :dark="dark" :color="dark ? 'primary' : ''" overlay-color="#000" width="300" app fixed v-model="show" left :temporary="!permanent" :permanent="permanent">
        <div class="drawer-header" @click="watermarkOpacity = 0.01">
            <span v-if="watermarkVisible" class="watermark x-small-text" :style="'opacity: ' + watermarkOpacity" @click.stop="showWatermark">[Developed by: Ebrahim Maher]</span>
            <div class=" d-flex justify-space-between align-center px-6 py-4">
                <div class="logo-wrapper my-2 ps-3">
                    <logo :white="dark" medium />
                </div>
                <v-btn v-if="phoneOnly || !isAuthed" large class="mb-1" icon @click.prevent="show=false">
                    <v-icon size="24">mdi-menu</v-icon>
                </v-btn>
            </div>
            
            <!-- <div v-if="isAuthed" class="d-flex align-center py-2 px-7">
                <div class="text-center">
                    <avatar :src="user.avatar" :size="50" :icon-size="35"/>
                </div>
                <div class="ms-2">
                    <div class="user-name ms-2" style="line-height: 1rem">{{user.name}}</div>
                    <v-btn dense small v-if="isAuthed" text @click="logoutDialog = true; show = false">تسجيل الخروج</v-btn>
                </div>
            </div> -->
        </div>
        <!-- <v-divider class="my-2" /> -->

        <v-list :dark="dark" nav class="px-4 py-0 transparent secondary--text">
            <template v-for="(item, i) in drawerRoutes">
                
                <v-divider class="mb-1" v-if="item.divider" :key="'d-' + i" />

                <v-list-item v-if="!item.show || self[item.show]" v-haptic v-show="!item.pcOnly || pcOnly" color="primary" :key="i" link :to="item.to" exact class="menu-list-item my-0 px-4 px-lg-5" v-ripple="phoneOnly" @click="openRoute(item.to)">
                    <v-list-item-icon class="me-4 my-auto">
                        <v-icon :color="activeRoute !== item.to.name ? 'text' : ''">{{ activeRoute === item.to.name ? item.icon.replace('-outline', '') : item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title style="font-size: 0.95rem; line-height: 1.4rem">{{item.name}}</v-list-item-title>
                    </v-list-item-content>

                </v-list-item>
            </template>
        </v-list>
        <v-divider class="my-5" />
        
        <div class="text-center">
            
            <div class="mt-2">
                <social-btns colored small />
            </div>

            <div v-if="!capRunning && !miniDerasaPlatform" class="store-badges d-flex align-center justify-center px-6 mt-2">
                <store-badge type="playstore" width="123px" />
                <store-badge type="appstore" width="95px" />
            </div>

            <div class="ltr-dir d-flex align-center justify-center mt-2">
                <div class="small-text muted--text mr-2">Powered By: </div>
                <a href="https://www.derasa.tech" :target="capRunning ? '_system' : '_blank'">
                    <img class="derasatech-logo" :src="asset('derasatech-logo/logo.png', 'img')" style="width: auto; height: 14px; opacity: 0.8"/>
                </a>
            </div>

            <div class="muted--text details-text">All Rights Reserved © 2024</div>

        </div>

        <logout-dialog v-model="logoutDialog" />
    </v-navigation-drawer>
    
</template>

<script>
import GlobalMethods from '@/helpers/global-methods'
import GlobalComputed from '@/helpers/global-computed'
import drawerRoutes from '@/helpers/links'
import StoreBadge from '../default/store-badge'
import Avatar from '../default/avatar'
import SocialBtns from '../main/social-btns'
import LogoutDialog from '../default/dialogs/logout'

export default {
    name: 'app-menu',
    props: ['value'],
    data(){
        return {
            self: this,
            show: false,
            watermarkOpacity: 0.01,
            logoutDialog: false,
            dark: false,

            watermarkVisible: false,
        }
    },
    components: {
        Avatar,
        SocialBtns,
        LogoutDialog,
        StoreBadge,
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    computed: {
        activeRoute(){
            return this.$route.name;
        },
        drawerRoutes(){
            return this.isAuthed ? drawerRoutes.auth : drawerRoutes.guest;
        },
        permanent(){
            return this.pcOnly && this.isAuthed && !this.$route.meta.temporaryMenu;
        },
        showExams(){
            return !!this.appData.enable_gen_exm;
        },
        showWallet(){
            return !!this.appData.enable_wallet_system;
        },
        showTeachers(){
            return !!this.appData.teachers_page;
        },
        showWrongAnswers(){
            return !!this.appData.enable_wrong_answers_page;
        },
        ...GlobalComputed
    },
    methods: {
        openRoute(to){
            if (this.phoneOnly){
                this.show = false;
                /* window.setTimeout(()=>{
                    this.$router.push(to);
                }, 400); */
            }else{
                /* this.$router.push(to); */
            }
        },
        showWatermark(){
            this.watermarkOpacity += 0.01;
        },
        openProfile(){
            let isProfile = this.$route.name === 'profile' && this.$route.params.id == this.user.id;
            if (!isProfile){
                this.$router.push({name: 'profile', params: {id: this.user.id}});
            }
        },
        ...GlobalMethods
    },
    mounted(){
        window.setTimeout(()=>{
            this.watermarkVisible = true;
        }, 10000);
    }
}
</script>

<style lang="scss" scoped>
.app-menu{
    transition: all 0.35s ease, background-color 0s linear;
    @media(max-width: 960px){
        transition: all 0.25s ease-in-out, background-color 0s linear;
    }
    
    .watermark{
        position: absolute;
        top: 0;
        user-select: none;
        line-height: 1.2rem;
        left: 4px;
        color: #000;
        text-transform: capitalize;
        z-index: 7;
    }
    .v-list-item.menu-list-item{
        margin-bottom: 7px!important;
        border-radius: 5px!important;
        overflow: hidden;
        height: 38px;
        
        &.v-list-item--active{
            &::before{
                opacity: 0.06;
            }
            &:hover::before{
                opacity: 0.1;
            }
            &:active::before{
                opacity: 0.14;
            }
        }
    }
}
</style>